<template>
  <tinymce-vue
    v-model="value"
    :api-key="apiKey"
    :init="tinyInit"
    :tinymce-script-src="tinymceScriptSrc"
    style="width: 100%"
    @change="handleInput"
  ></tinymce-vue>
</template>
<script>
import TinymceVue from '@tinymce/tinymce-vue'
import SparkMD5 from 'spark-md5'
export default {
  name: 'TinymceEditor',
  components: {TinymceVue},
  props: {
    value: String,
    uploadPath: {
      type: String,
      default: 'https://upload.qiniup.com'
    },
    attrs: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    tinyInit() {
      return {
        height: this.attrs.height || 350,
        resize: false,
        menubar: true,
        language: 'zh_CN',
        base_url: '',
        target_list: [{title: '在新窗口打开', value: '_blank'}],
        plugins: 'lists image table wordcount code link hr preview searchreplace paste',
        toolbar: 'undo redo | fontselect formatselect | bold italic hr forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists image table | code searchreplace link preview | removeformat',
        font_formats: '微软雅黑=Microsoft Yahei,Helvetica Neue,PingFang SC,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;',
        images_upload_handler: (blobInfo, succFun, failFun) => {
          let file = blobInfo.blob()
          this.uploadFile(file).then((res) => {
            succFun(res.url)
          }).catch((e) => {
            failFun(e)
          })
        },
        file_picker_callback: (callback, value, meta) => {
          let _input = document.createElement('input')
          _input.setAttribute('type', 'file')
          _input.click()
          _input.onchange = ((e) => {
            let file = e.target.files[0]
            this.uploadFile(file).then((res) => {
              callback(res.url, {
                text: res.name
              })
            }).catch(e => null)
          })
        }
      }
    },
    editorValue() {
      return this.value
    }
  },
  data() {
    return {
      tinymceScriptSrc: 'https://htpscdn.enjoy5191.com/static/tinymce/tinymce.min.js',
      apiKey: 'yis5yczcpq7hybzct8wao3kzbtzbmfkk53s45jkevir7vrpi'
    }
  },
  watch: {
    editorValue() {
      this.handleInput()
    }
  },
  methods: {
    uploadFile(file) {
      let {uploadPath} = this
      return new Promise((resove, reject) => {
        this.readFileMD5(file, () => {
          let formData = new FormData()
          formData.append('file', file)
          formData.append('token', file.token)
          formData.append('key', file.key)
          axios({
            url: uploadPath,
            data: formData,
            method: 'post',
            withCredentials: true
          }).then(res => {
            resove(res)
          }).catch(e => {
            reject(e)
          })
        })
      })      
    },
    readFileMD5(file, call) {
      if(file.md5 || file.token) {
        // 若是已经读取MD5码，则跳过
      } else {
        let instanceOfBlob = new Blob([file], {type: ''})
        let chunkSize = 2091752
        let chunkCount = Math.ceil(file.size / chunkSize)
        let currentChunk = 0
        let spark = new SparkMD5.ArrayBuffer()
        let fileReader = new FileReader()

        const loadNext = () => {
          let start = currentChunk * chunkSize
          let end = start + chunkSize
          if(end >= file.size) {
            end = file.size
          }
          let chunk = instanceOfBlob.slice(start, end)
          fileReader.readAsArrayBuffer(chunk)
        }

        fileReader.onload = (e) => {
          let {result} = e.target.result
          spark.append(result)
          currentChunk++
          if(currentChunk < chunkCount) {
            loadNext()
          } else {
            let md5 = spark.end().toUpperCase()
            file.md5 = md5
            this.setFileToken(file, call)
          }
        }
      }
    },
    setFileToken(file, call) {
      axios.get(`/File/QNToken`, {
        params: {
          md5: file.md5,
          ieTime: Date.now()
        }
      }).then((res) => {
        let {uptoken} = res
        let guid = `${Date.now()}${getFileType(file)}${file.size}`
        let key = `${guid}/${file.name}`
        file.key = key
        file.token = uptoken
        call && call()
      }).catch(() => {
        this.$message.error('获取上传文件令牌失败！请联系客服')
      })      
    },
    getFileType(file) {
      let {name} = file
      let index = name.lastIndexOf('.')
      return name.slice(index + 1)      
    },
    handleInput() {
      this.$emit('modelValue:update')
      this.$emit('input')
    }
  }
}
</script>
